import { UserDetailPage } from "fleet/view/user/detail";
import { connect } from "react-redux";
import { createPromiseApiAction } from "redux-store/api-sagas";
import { getAuthUser } from "redux-store/auth";
import * as FeatureFlags from "redux-store/feature-flags/selectors";
import { networksSelector } from "redux-store/networks";
import { defaultObject, makeGetSelectOptions } from "redux-store/selectors";
import { EDIT_USER, INVITE_USER } from "redux-store/users/actions";
import { usersSelector } from "redux-store/users/selectors";
import { storesReady } from "redux-store/utils";
import { withProps } from "ui/props";
import { VIEW } from "view/views";

const getNetworkSelectOptions = makeGetSelectOptions();

function mapStateToProps(state, props) {
  const { id: userId } = props.match.params || {};
  const storesLoaded = storesReady(state.global.users, state.global.networks);
  const networks = networksSelector(state);
  const networkOptions = getNetworkSelectOptions(networks);
  const users = usersSelector(state);
  const user = users[userId] || defaultObject;
  const currentUser = getAuthUser(state);
  const featureFlags = FeatureFlags.getFeatureFlags(state);

  return {
    networkOptions,
    storesLoaded,
    user,
    currentUser,
    featureFlags,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    editUser: (serviceArgs) => {
      const { id, role, networkIds } = serviceArgs;
      return createPromiseApiAction(dispatch, EDIT_USER, [
        id,
        role,
        networkIds,
      ]);
    },
    inviteUser: (serviceArgs) => {
      const { name, email, role, networkIds } = serviceArgs;
      return createPromiseApiAction(dispatch, INVITE_USER, [
        name,
        email,
        role,
        networkIds,
      ]);
    },
  };
}

const EditUser = withProps(UserDetailPage, { type: VIEW.EDIT });
const NewUser = withProps(UserDetailPage, { type: VIEW.CREATE });

const ConnectedUserEditPage = connect(
  mapStateToProps,
  mapDispatchToProps,
)(EditUser);
const ConnectedUserNewPage = connect(
  mapStateToProps,
  mapDispatchToProps,
)(NewUser);

export { ConnectedUserEditPage, ConnectedUserNewPage };
